import Banner from "../../images/banner.jpg";
import "./Terms.css";
import Footer from "../Footer/Footer";
import NavBar from "../Layout/NavBar";

const Terms = () => {
  const year = new Date().getFullYear();

  return (
    <div className="terms-home">
      {/* Banner */}
      <div className="terms-banner">
        <img src={Banner} alt="Flickerbound Banner" />
      </div>

      <NavBar />

      <div className="terms-container">
        <h1>Terms of Service</h1>
        <p className="updated-date">Last updated: {year}</p>

        <section>
          <h2>Introduction</h2>
          <p>
            These Terms of Service (“Terms”) govern your use of the Flickerbound
            website located at <strong>https://flickerbound.com</strong> (“the
            Site”). By accessing or using the Site, you agree to be bound by
            these Terms. If you do not agree, please discontinue use of the
            Site.
          </p>
        </section>

        <section>
          <h2>Use of the Site</h2>
          <p>
            You agree to use the Site only for lawful purposes and in a manner
            that does not infringe upon the rights of others or restrict their
            use of the Site. You may not:
          </p>
          <ul>
            <li>Attempt to gain unauthorized access to the Site or its systems</li>
            <li>Interfere with the Site’s functionality or security</li>
            <li>Use automated tools to scrape or collect data without permission</li>
            <li>Upload harmful or malicious content</li>
          </ul>
        </section>

        <section>
          <h2>Purchases and Payments</h2>
          <p>
            When you make a purchase through the Site, you agree to provide
            accurate payment information. All payments are processed securely
            through third‑party providers such as Stripe or PayPal. Prices,
            promotions, and product availability may change without notice.
          </p>
        </section>

        <section>
          <h2>Intellectual Property</h2>
          <p>
            All content on the Site—including images, artwork, text, branding,
            and product designs—is owned by Flickerbound and protected by
            copyright and trademark laws. You may not copy, reproduce,
            distribute, or modify any content without written permission.
          </p>
        </section>

        <section>
          <h2>User Content</h2>
          <p>
            If you submit content to the Site (such as messages, reviews, or
            feedback), you grant Flickerbound a non‑exclusive license to display,
            modify, or use that content for business purposes. You are
            responsible for ensuring your submissions do not violate any laws or
            infringe on the rights of others.
          </p>
        </section>

        <section>
          <h2>Third‑Party Links</h2>
          <p>
            The Site may contain links to third‑party websites. We are not
            responsible for the content, policies, or practices of these
            external sites. Accessing third‑party links is at your own risk.
          </p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Flickerbound is not liable
            for any damages arising from:
          </p>
          <ul>
            <li>Use or inability to use the Site</li>
            <li>Errors, interruptions, or technical issues</li>
            <li>Third‑party services or content</li>
            <li>Unauthorized access to your data</li>
          </ul>
          <p>
            Your use of the Site is at your own risk. We provide the Site “as
            is” without warranties of any kind.
          </p>
        </section>

        <section>
          <h2>Changes to These Terms</h2>
          <p>
            We may update these Terms at any time. Continued use of the Site
            after changes are posted constitutes acceptance of the updated
            Terms.
          </p>
        </section>

        <section>
            <h2>Contact Us</h2>
            <p>
                If you have questions about these Terms, you can reach us at:
            </p>
            <p>
                You may contact us through our website’s Contact page:
            </p>
            <p>
                <strong>https://flickerbound.com/contact</strong>
            </p>
        </section>

      </div>

      <Footer />
    </div>
  );
};

export default Terms;
